import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {useLoaderData, useNavigate} from "react-router-dom";
import {Avatar, Container, Stack, Button, CardActionArea} from "@mui/material";
import FaceIcon from '@mui/icons-material/Face';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import closedChest from "../assets/sword.png";

export default function Players() {
    const players = useLoaderData();
    const navigate = useNavigate();

    const navigateToGames = (player) => {
        localStorage.setItem('player', player.id);
        navigate("/games")
    };

    const navigateToNewPlayer = () => {
        navigate("/players/new")
    };

    return (
        <>
            <Container maxWidth="sm" sx={{
                display: 'flex',
                flexDirection: 'row',
                mb: 4,
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img src={closedChest} alt={'closed chest'} width={60}/>
                <Typography variant="h5" align="center" color="text.secondary" paragraph sx={{ ml: 1 }}>
                    Qui joue ?
                </Typography>
            </Container>
            <Grid container spacing={4} sx={{ pl: 5, pr: 5, pt: 1 }} alignItems="center" justify="center"
                  direction="column">
                {players.map((player) => {
                    return (
                        <Grid item key={player} xs={12} sm={6} md={4}>
                            <Card
                                sx={{ height: '100%', width: '100%', minWidth: '200px', display: 'flex', flexDirection: 'column' }}
                            >
                                <CardActionArea onClick={() => navigateToGames(player)}>
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            flexGrow: 1,
                                            flexDirection: 'column',
                                            alignItems: "center"
                                        }}>
                                        <Avatar sx={{ width: 75, height: 75 }}>
                                            <FaceIcon fontSize={'large'}/>
                                        </Avatar>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {player.name}
                                        </Typography>
                                        <Typography sx={{ color: "#AAAAAA" }}>
                                            tag : #{player.tag}
                                        </Typography>
                                        <Typography>
                                            Or : {player.gold}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
            <Stack
                sx={{ pt: 4 }}
                direction="row"
                spacing={2}
                justifyContent="center"
            >
                <Button variant="contained" onClick={() => navigateToNewPlayer()}>
                    <AddCircleIcon sx={{ mr: 1 }}/> Nouveau joueur
                </Button>
            </Stack>
        </>
    );
}
